<template>
  <div style="width: 100%; min-height: 75vh;">
    <b-row class="justify-content-center">
      <b-col cols="2" style="padding: 0px;">
        <div @click="() => { click(-this.weekOffset) }" class="button button-left">today</div>
      </b-col>
      <b-col cols="2" offset-sm="0" offset-lg="1" style="padding: 0px;">
        <div @click="() => { click(-1) }" class="previous">&laquo; Prev</div>
      </b-col>
      <b-col sm="4" md="4" lg="2" style="padding: 0px;">
        <div style="line-height: 2.3rem;">{{ this.formatDate(this.startDate) + ' - ' + this.formatDate(this.endDate) }}</div>
      </b-col>
      <b-col cols="2" style="padding: 0px;">
        <div @click="() => { click(1) }" class="next">Next &raquo;</div>
      </b-col>
      <b-col cols="2" offset-lg="1" style="padding: 0px;" >
        <div @click="() => { this.goToMainView() }" class="button button-right">month</div>
      </b-col>
    </b-row>
    <b-row>
      <div class="scroll-area" style="width: 100%">
        <b-row align-h="center" class="title-row" :no-gutters="true">
          <b-col style="padding-right: 3px;" cols="12" sm="6" md="3" v-if="this.releaseDates.length > 0">
            <div v-for="(releaseDate) in this.releaseDateColumn(0, 4)" :key="releaseDate._id.gameId + '-' + releaseDate._id.date">
              <GameCard :releaseDate="releaseDate"/>
            </div>
          </b-col>
          <b-col style="padding-left: 3px; padding-right: 3px;" cols="12" sm="6" md="3" v-if="this.releaseDates.length > 0">
            <div v-for="(releaseDate) in this.releaseDateColumn(1, 4)" :key="releaseDate._id.gameId + '-' + releaseDate._id.date">
              <GameCard :releaseDate="releaseDate"/>
            </div>
          </b-col>
          <b-col style="padding-left: 3px; padding-right: 3px;" cols="12" sm="6" md="3" v-if="this.releaseDates.length > 0">
            <div v-for="(releaseDate) in this.releaseDateColumn(2, 4)" :key="releaseDate._id.gameId + '-' + releaseDate._id.date">
              <GameCard :releaseDate="releaseDate"/>
            </div>
          </b-col>
          <b-col style="padding-left: 3px;" cols="12" sm="6" md="3" v-if="this.releaseDates.length > 0">
            <div v-for="(releaseDate) in this.releaseDateColumn(3, 4)" :key="releaseDate._id.gameId + '-' + releaseDate._id.date">
              <GameCard :releaseDate="releaseDate"/>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-row>
  </div>
</template>

<script>
import GameCard from './GameCard'
import moment from 'moment'

export default {
  name: 'pinboard',
  components: {
    GameCard
  },
  data () {
    return {
      weekOffset: 0,
      fetchRangeInDays: 6,
      loadBalancer: false
    }
  },
  metaInfo () {
    return {
      titleTemplate: 'Video game release week calendar | WhenIsGameReleased.com',
      htmlAttrs: {
        lang: 'en'
      },
      meta: [{
        vmid: 'description',
        name: 'description',
        content: 'Video games that were released this week'
      }]
    }
  },
  computed: {
    sortedReleaseDates () {
      let toBeSorted = this.releaseDates.slice()
      return toBeSorted.sort((a, b) => new Date(a.date) - new Date(b.date))
    },
    releaseDates () {
      return this.$store.state.releaseDates || []
    },
    startDate () {
      return moment().utc().add(this.weekOffset * 7, 'days').startOf('day').format()
    },
    endDate () {
      return moment().utc().add((this.weekOffset * 7) + this.fetchRangeInDays, 'days').endOf('day').format()
    },
    selectedDate () {
      return moment(this.startDate).utc().format('DD.MM.YYYY')
    }
  },
  methods: {
    releaseDateColumn (col, cols) {
      return this.sortedReleaseDates.reduce((acc, cur, idx) => {
        if (idx % cols === col) acc.push(cur)
        return acc
      }, [])
    },
    loader (startDate, endDate) {
      this.$store.dispatch('getReleaseDatesByDates', { startDate, endDate })
    },
    click (addition) {
      this.weekOffset += addition
      this.$session.set('weekOffset', this.weekOffset)
      this.loader(this.startDate, this.endDate)
    },
    goToMainView () {
      this.$router.push('/')
    },
    formatDate (date) {
      return moment(date).format('DD.MM.YYYY')
    }
  },
  mounted () {
    let initOffset = this.$session.get('weekOffset')

    if (initOffset) {
      this.weekOffset = initOffset
    } else {
      this.$session.set('weekOffset', 0)
    }

    this.loader(this.startDate, this.endDate)
  }
}
</script>
<style>
.next, .previous, .button {
  text-decoration: none;
  display: inline-block;
  padding: 8px 16px;
}

.button-left {
  float: left;
}

.button-right {
  float: right;
}

.next:hover, .previous:hover, .button:hover {
  background-color: #CFD0D1;
  color: #222222;
  cursor: pointer;
}

.next, .previous, .button {
  background-color: #222222;
  color: #cfd0d1;
  border-radius: 5%;
}

@media (max-width: 768px) {
  .scroll-area {
    height: 73vh;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
